<template>
  <div class="block">
    <h4>
      <span class="required">*</span>
      Carga el audio de tu IVR
    </h4>

    <div class="block block--light info" v-if="typeStrategy === TypeStrategy.IvrReturn">
      <InfoCircleOutlined class="icon" />
      <span class="info--text" action="Cerrar">
        Es necesario que tu audio mencione digitar un número para transferir la llamada hacia la cola.
      </span>
    </div>

    <audio-picker
      class="audio-picker"
      v-model:value="_audioIvr"
      width-full
      filled
      title="Sube aquí tu archivo de audio aquí"
    />

    <a-button
      class="button_listen"
      type="link"
      v-if="_audioIvr != undefined"
      @click="visible = true"
    >
      Escuchar audio cargado
      <PlayCircleOutlined />
    </a-button>
  </div>

  <a-modal 
    width="484px"
    v-model:open="visible" 
    :footer="null" 
    centered
    destroyOnClose
  >
    <template #title>Escuchar audio</template>
    <p>
      Tu IVR reproducirá el siguiente audio cargado.
    </p>
    <CallAudioPlayer
      :audio-url="audioUrl"
      :rate-items="rateItems"
      volumen="vertical"
    />
  </a-modal>
</template>

<script>
import { InfoCircleOutlined, PlayCircleOutlined } from "@ant-design/icons-vue";
import AudioPicker from "@/app/shared/components/molecules/AudioPicker.vue";
import CallAudioPlayer from "@/app/supervision/components/audio/CallAudioPlayer.vue";
import { TypeStrategy } from "@/@types/strategies/modalStrategy";

export default {
  components: {
    InfoCircleOutlined,
    AudioPicker,
    PlayCircleOutlined,
    CallAudioPlayer,
  },
  props: {
    audioIvr: {
      required: true,
      type: Number,
    },
    typeStrategy: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      TypeStrategy,
    };
  },
  computed: {
    _audioIvr: {
      get() {
        return this.audioIvr;
      },
      set(value) {
        this.$emit("update:audioIvr", value);
      },
    },
    audioUrl() {
      if (this._audioIvr) {
        return URL.createObjectURL(this._audioIvr);
      }
      return null;
    },
  },
  methods: {
    
  },
};
</script>

<style lang="sass" scoped>
.block
  padding: 28px 12px 20px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px

  &--light
    border: 1px solid #dcdcdc
    color: $gray-7
    padding: 8px 12px
    margin: 4px 0 12px 0

.info
  display: flex

  &--text
    font-size: 12px

.icon
  margin: 3px 6px 0 0

.required
  color: $red-7
  margin-right: 2px

.audio-picker
  .picker__text
    font-weight: 500

.button_listen
  display: block
  margin: 0 auto
</style>
